import LANDING_V4_TESTIMONIALS from '~/landingV4/consts/testimonials.const'

import TestimonialCard from './TestimonialCard'

const MARQUEE_STYLES = `
.v4-marquee-track { animation: v4-marquee-scroll 60s linear infinite; }
.v4-marquee:hover .v4-marquee-track { animation-play-state: paused; }
@keyframes v4-marquee-scroll {
  from { transform: translateX(0); }
  to { transform: translateX(-50%); }
}
@media (prefers-reduced-motion: reduce) {
  .v4-marquee-track { animation: none; }
}
`

export default function TestimonialsMarquee(): React.ReactElement {
  return (
    <div className="v4-marquee relative w-full overflow-hidden py-6">
      <style dangerouslySetInnerHTML={{ __html: MARQUEE_STYLES }} />
      <div className="v4-marquee-track flex w-max">
        <div className="flex gap-4 pr-4">
          {LANDING_V4_TESTIMONIALS.map((item) => (
            <TestimonialCard key={item.id} testimonial={item} />
          ))}
        </div>
        <div aria-hidden className="flex gap-4 pr-4">
          {LANDING_V4_TESTIMONIALS.map((item) => (
            <TestimonialCard key={`dup-${item.id}`} testimonial={item} />
          ))}
        </div>
      </div>
    </div>
  )
}
